// extracted by mini-css-extract-plugin
export default {"title":"_1XHcKIEO","subtitle":"_8paFvB15","description":"az3vUN4b"};